import {QtyWithPreview} from "./QtyWithPreview";
import {SimpleIconButton} from "../../../misc/lists/SimpleIconButton";
import Clear from "@mui/icons-material/Clear";
import {RouteStopGroup} from "../../../api/Logistics";
import {api} from "../../../api/API";
import {useSnackbar} from "../../../misc/Snackbar";
import {RefreshRouteItems} from "./RouteItems";
import {routePopupPanel} from "./RouteList";
import {Completed} from "./Completed";
import {AuditLogIconPopper} from "./AuditLogIconPopper";

export function DropDeliveryRow(props: {
    value: RouteStopGroup;
    routeCompleted: boolean;
    canRemove: boolean;
}) {
    const snack = useSnackbar();

    return (
        <tr>
            <td>Delivery from warehouse</td>
            <td>
                <div style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
                    <QtyWithPreview data={props.value.items || []}/>
                    <AuditLogIconPopper group={props.value.id}/>
                </div>
            </td>
            <td>
                <Completed contents={props.value.items || []} routeComplete={props.routeCompleted} complete={props.value.completed} />
            </td>
            <td>
                <div className="actions">
                    {props.canRemove && <SimpleIconButton disabled={props.value.completed} onClick={async () => {
                        try {

                            await api.logistics.upsertStopGroup(Object.assign({}, props.value, {
                                archived: true,
                            }))

                        } catch (e: any) {
                            snack.error(e.toString())
                            return;
                        }

                        RefreshRouteItems.emit({
                            updatedByUs: true,
                        });
                        routePopupPanel.sendToClient("refresh-to-move")
                        snack.success("Updated")
                    }}>
                        <Clear />
                    </SimpleIconButton>}
                </div>
            </td>
        </tr>
    )
}